import React from 'react';
import { Section } from './ui/Section';
import { Wind, Activity, Clock, FileText } from 'lucide-react';
export function SolutionSection() {
  return <Section background="dark" className="relative overflow-hidden" data-id="element-182">
      <div className="relative z-10" data-id="element-183">
        <div className="text-center mb-12" data-id="element-184">
          <span className="text-amber-400 font-semibold tracking-wider text-sm uppercase" data-id="element-185">
            La Solución
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mt-2" data-id="element-186">
            Protocolo 3 Capas + Plan de Rescate
          </h2>
          <p className="text-slate-400 mt-4 max-w-xl mx-auto" data-id="element-187">
            3AM RESET funciona porque no depende de tu motivación. Te da un
            sistema.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3 mb-12" data-id="element-188">
          {/* Layer 1 */}
          <div className="bg-slate-800/50 backdrop-blur p-6 rounded-xl border border-slate-700" data-id="element-189">
            <div className="w-12 h-12 bg-indigo-900/50 rounded-lg flex items-center justify-center mb-4" data-id="element-190">
              <Wind className="w-6 h-6 text-indigo-400" data-id="element-191" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-192">
              Capa 1: Ambiente
            </h3>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-193">
              Ajustes reales para que tu cuarto deje de picarle al cuerpo:
              temperatura, telas, luz, buró limpio, celular fuera del alcance.
            </p>
          </div>

          {/* Layer 2 */}
          <div className="bg-slate-800/50 backdrop-blur p-6 rounded-xl border border-slate-700" data-id="element-194">
            <div className="w-12 h-12 bg-indigo-900/50 rounded-lg flex items-center justify-center mb-4" data-id="element-195">
              <Activity className="w-6 h-6 text-indigo-400" data-id="element-196" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-197">
              Capa 2: Sistema Nervioso
            </h3>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-198">
              Herramientas breves para bajar alarma interna: descarga física
              corta + respiración con exhalación larga + cierre mental.
            </p>
          </div>

          {/* Layer 3 */}
          <div className="bg-slate-800/50 backdrop-blur p-6 rounded-xl border border-slate-700" data-id="element-199">
            <div className="w-12 h-12 bg-indigo-900/50 rounded-lg flex items-center justify-center mb-4" data-id="element-200">
              <Clock className="w-6 h-6 text-indigo-400" data-id="element-201" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-202">
              Capa 3: Rutina Mínima
            </h3>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-203">
              Una secuencia de 10 minutos tan simple que la puedes hacer incluso
              cansada.
            </p>
          </div>
        </div>

        {/* Rescue Plan Highlight */}
        <div className="bg-amber-500/10 border border-amber-500/30 rounded-2xl p-8 md:p-10" data-id="element-204">
          <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-205">
            <div className="bg-amber-500/20 p-4 rounded-full flex-shrink-0" data-id="element-206">
              <FileText className="w-8 h-8 text-amber-400" data-id="element-207" />
            </div>
            <div data-id="element-208">
              <h3 className="text-2xl font-serif font-bold text-white mb-3" data-id="element-209">
                Y lo más importante: El Plan de Rescate 3AM
              </h3>
              <p className="text-slate-300 mb-4" data-id="element-210">
                Un guion paso a paso para cuando despiertas. Porque a esa hora,
                improvisar es perder.
              </p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-slate-400" data-id="element-211">
                <li className="flex items-center gap-2" data-id="element-212">
                  <span className="w-1.5 h-1.5 bg-amber-400 rounded-full" data-id="element-213"></span>
                  Qué no hacer (mirar la hora)
                </li>
                <li className="flex items-center gap-2" data-id="element-214">
                  <span className="w-1.5 h-1.5 bg-amber-400 rounded-full" data-id="element-215"></span>
                  Qué hacer en los primeros minutos
                </li>
                <li className="flex items-center gap-2" data-id="element-216">
                  <span className="w-1.5 h-1.5 bg-amber-400 rounded-full" data-id="element-217"></span>
                  Cómo sacar a tu mente del carrusel
                </li>
                <li className="flex items-center gap-2" data-id="element-218">
                  <span className="w-1.5 h-1.5 bg-amber-400 rounded-full" data-id="element-219"></span>
                  Qué hacer si pasan 20–30 minutos
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}